// extracted by mini-css-extract-plugin
export default {"itemBtn":"itemBtn--rjK2N","name":"name--ZE_Gd","kind-blue":"kind-blue--Zfpty","icon":"icon--YCeu1","photo":"photo--LcAVR"};